import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRegionDropDown } from "Store/Organization/Region/RegionAction";
import { getMarketDropDown } from "Store/Organization/Market/MarketAction";
import { getCostCenterByMarket } from "Store/Organization/CostCenterByMarket/CostCenterByMarketAction";
import {
  base64ToArrayBuffer,
  formatPrice,
  saveByteArray,
} from "utils";
import {
  getActiveAssetReportDropdownGridData,
  getActiveAssetReportExcelData,
  getActiveAssetReportGridData,
  setActiveAssetReportExcelData,
  setActiveAssetReportGridFilter,
} from "Store/AssetManagement/ActiveAssetReport/ActiveAssetReportAction";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import userProfileSelectors from "redux/UserProfile/selectors";
import { CustomDateFilterComponent, CustomDropdownFilterComponent } from "client/Components/OrderManagement/BulkOrder/Home/HomeHelper";
import moment from "moment";
import ActiveAssetRegister from "../ActiveAssetRegisters/ActiveAssetRegisters";

const ActiveAssetReportContainer = () => {
  const [regionDropDownList, setRegionDropDownList] = useState<any>([]);
  const [selectedRegion, setSelectedRegion] = useState<any>();

  const [marketDropDownList, setMarketDropDownList] = useState<any>([]);
  const [selectedMarket, setSelectedMarket] = useState<any>();

  const [costCenterDropdownList, setCostCenterDropdownList] = useState([]);
  const [selectedCostCenter, setSelectedCostCenter] = useState<any>();

  const [globalSearchBy, setGlobalSearchBy] = useState<any>({
    value: "assetNumber",
    label: "Asset#",
  });
  const [searchBoxValue, setsearchBoxValue] = useState("");
  const [showGrid, setShowGrid] = useState(false);
  const [serverTotal, setServerTotal] = useState(0);
  const [paginationData, setPaginationData] = useState<any>({});
  const [pagesCount, setPagesCount] = useState<number>(0);
  const [sortData, setSortData] = useState<any>({});
  const [isClearFilterClicked, setIsClearFilterClicked] =
    useState<boolean>(false);
  const [savedMarket, setSavedMarket] = useState<any>("");
  const [savedCostCenter, setSavedCostCenter] = useState<any>("");
  const [sentPayload, setSentPayload] = useState<any>({});
  const [gridRemountKey, setGridRemountKey] = useState<number>(0);

  const [selectedDate, setSelectedDate] = useState<any>();
  const [isDateFilterClicked, setIsDateFilterClicked] = useState<boolean>(false);
  const prevSelectedDate = useRef<Date | null>(null);
  const isInitialSet = useRef<boolean>(true);

  /// useRef for filter dropdown list
  const glCategoryList: any = useRef([]);
  const equipmentClassList: any = useRef([]);
  const yearList: any = useRef([]);
  const stateList: any = useRef([]);
  const parentList: any = useRef([]);

  /// useRef for filter dropdowns
  const glCategorySelected: any = useRef([]);
  const equipmentClassSelected: any = useRef([]);
  const yearSelected: any = useRef([]);
  const stateSelected: any = useRef([]);
  const parentSelected: any = useRef([]);

  // useRef for date filter
  const placedInService = useRef<any>(null);
  const importDate = useRef<any>(null);

  /// useRef for text filter
  const assetNumberSelected: any = useRef([]);
  const companyNumberSelected: any = useRef([]);
  const unitNumberSelected: any = useRef([]);
  const vinNumberSelected: any = useRef([]);
  const equipmentClassDescSelected: any = useRef([]);
  const descriptionSelected: any = useRef([]);
  const acquisitionCostSelected: any = useRef([]);
  const netBookedValueSelected: any = useRef([]);
  const parentNumberSelected: any = useRef([]);
  const usefulLifeMonthsSelected: any = useRef([]);
  const remainingLifeMonthsSelected: any = useRef([]);
  const currentMonthDepreciationSelected: any = useRef([]);
  const runRateDepreciationSelected: any = useRef([]);

  const previousGlobalSearchSignatureRef: any = useRef<string | null>(null);
  const resetToFirstPageOnNextFetchRef: any = useRef<boolean>(false);
  const remountGridOnNextResponseRef: any = useRef<boolean>(false);
  const dispatch = useDispatch();

  const [gridData, setGridData] = useState([]);

  /// date filter
  const [lastImportDate, setLastImportDate] = useState<any>(null);
  const [minImportDate, setMinImportDate] = useState<any>(null);
  const [validStartDate, setValidStartDate] = useState<any>(null);
  const [validEndDate, setValidEndDate] = useState<any>(null);

  ///selectors
  const {
    regionDropDown = [],
    marketDropDown = [],
    costCenterByMarketDropDownList = [],
    activeAssetReportExcelData,
    activeAssetReportGridFilters,
    activeAssetReportGridData,
    userDetails,
    isReportGridDataLoading,
    activeAssetReportDropdownGridData,
  }: any = useSelector((state: any) => ({
    regionDropDown: state?.RegionDropDownReducer?.regionDropDown,
    marketDropDown: state?.MarketDropDownReducer?.marketDropDown,
    costCenterByMarketDropDownList:
      state.CostCenterByMarketReducers.costCenterByMarket,
    activeAssetReportExcelData:
      state.ActiveAssetReportReducer.activeAssetReportExcelData,
    activeAssetReportGridFilters:
      state.ActiveAssetReportReducer.activeAssetReportGridFilters,
    activeAssetReportGridData:
      state.ActiveAssetReportReducer.activeAssetReportGridData,
    userDetails: userProfileSelectors.getUserDetails(state),
    isReportGridDataLoading:
      state.ActiveAssetReportReducer.isReportGridDataLoading,
    activeAssetReportDropdownGridData:
      state.ActiveAssetReportReducer.activeAssetReportDropdownGridData,
  }));


  useEffect(() => {
    dispatch(getRegionDropDown());
    dispatch(getActiveAssetReportDropdownGridData());
    setShowGrid(true);
    setSentPayload({})
  }, []);

  const getDropdownPayload = () => {
    if(selectedDate != null){
    return {
      ImportYear: moment(selectedDate).format("YYYY"),
      ImportMonth: moment(selectedDate).format("MM"),
    };
   }
  };

  const adjustDate = (dateString: any) => {
    return moment(dateString).subtract(1, 'months');
  };

  useEffect(() => {
    if (activeAssetReportGridData?.status == "success") {
      setIsClearFilterClicked(false);
      setServerTotal(activeAssetReportGridData?.response?.totalRecords);

      if (activeAssetReportGridData?.response?.data?.length) {
        const updatedOrderList = activeAssetReportGridData?.response?.data?.map((item: any) => (
          {
            ...item,
            importDate: moment(item.importDate).format('MM/DD/YYYY'),
            placedInService: moment(item.placedInService).format('MM/DD/YYYY'),
          }
        ))
        setGridData(updatedOrderList);
      } else {
        setGridData([]);
      }

      if (remountGridOnNextResponseRef.current) {
        remountGridOnNextResponseRef.current = false
        setShowGrid(false)
        setTimeout(() => {
          setShowGrid(true);
        })
      }
    }
  }, [activeAssetReportGridData]);

  useEffect(() => {
    if (regionDropDown?.length) {
      const regionDropDownTemp = regionDropDown?.map((item: any) => ({
        label: item.text,
        key: item.value,
        ...item,
      }));
      setRegionDropDownList(regionDropDownTemp);
    }
  }, [regionDropDown]);

  useEffect(() => {
    if (marketDropDown?.length) {
      const marketDropDownTemp = marketDropDown?.map((item: any) => ({
        label: item.text,
        key: item.value,
        ...item,
      }));
      setMarketDropDownList(marketDropDownTemp);
      if (savedMarket) {
        let val = marketDropDownTemp?.find(
          (val?: any) => val.key == savedMarket
        );
        setSelectedMarket(val);
        setSavedMarket("");
        dispatch(
          setActiveAssetReportGridFilter({
            ...activeAssetReportGridFilters,
            market: val,
          })
        );
      }
    }
  }, [marketDropDown]);

  useEffect(() => {
    if (costCenterByMarketDropDownList?.length) {
      const costCenterDropdownListTemp = costCenterByMarketDropDownList?.map(
        (item: any, _index: number) => ({
          ...item,
          label: item?.text,
          key: item?.value,
        })
      );
      setCostCenterDropdownList(costCenterDropdownListTemp);
      if (savedCostCenter) {
        let val = costCenterDropdownListTemp?.find(
          (val?: any) => val.key == savedCostCenter
        );
        setSelectedCostCenter(val);
        setSavedCostCenter("");
        dispatch(
          setActiveAssetReportGridFilter({
            ...activeAssetReportGridFilters,
            costCenterSearch: val,
          })
        );
      }
    }
  }, [costCenterByMarketDropDownList]);

  useEffect(() => {
    if (activeAssetReportDropdownGridData != null &&
      activeAssetReportDropdownGridData?.status == "success" &&
      activeAssetReportDropdownGridData?.response) {
      glCategoryList.current =
        activeAssetReportDropdownGridData?.response?.dropDownAssetCategory?.map(
          (item: any) => ({ label: item?.text, value: item?.value })
        );
      equipmentClassList.current =
        activeAssetReportDropdownGridData?.response?.dropDownAssetClassCode?.map(
          (item: any) => ({ label: item?.text, value: item?.value })
        );
      yearList.current =
        activeAssetReportDropdownGridData?.response?.dropDownAssetYear?.map(
          (item: any) => ({ label: item?.text, value: item?.value })
        );
      stateList.current =
        activeAssetReportDropdownGridData?.response?.dropDownAssetState?.map(
          (item: any) => ({ label: item?.text, value: item?.value })
        );
      parentList.current =
        activeAssetReportDropdownGridData?.response?.dropDownAssetParentType?.map(
          (item: any) => ({ label: item?.text, value: item?.value })
        );
      
      setLastImportDate(adjustDate(activeAssetReportDropdownGridData?.response?.lastImportDate));
      setMinImportDate(adjustDate(activeAssetReportDropdownGridData?.response?.minImportDate));
    }
  }, [activeAssetReportDropdownGridData]);

  
  useEffect(() => {
    setCurrentMonthDateFilter();
    const monthGap = lastImportDate?.diff(minImportDate, 'months');
    setValidStartDate(minImportDate);
    setValidEndDate(lastImportDate);

    if (monthGap > 6) {
      setValidStartDate(lastImportDate?.clone()?.subtract(6, 'months'));
    }
  }, [lastImportDate, minImportDate])

  const alreadyHasValues = () => {
    let isAlreadyHasValues = false;
    Object.keys(clearFilterValues)?.forEach((filterItem?: any) => {
      Object.keys(activeAssetReportGridFilters ?? {})?.forEach(
        (gridItem?: any) => {
          if (filterItem == gridItem) {
            isAlreadyHasValues = true;
          }
        }
      );
    });
    return isAlreadyHasValues;
  };

  const setSavedFilterValues = () => {
    if (
      userDetails?.hasOwnProperty("userGridFilters") &&
      regionDropDownList?.length > 0
    ) {
      if (!alreadyHasValues()) {
        let filterObj: any = [];
        userDetails?.userGridFilters?.map((item: any) => {
          if (item?.pageName == "Active Asset") {
            item?.gridFilter?.map((itemVal?: any) => {
              if (itemVal?.gridName == "Report")
                itemVal?.filterValues?.map((val?: any) => {
                  if (
                    val?.filterName == "region" &&
                    regionDropDownList?.length > 0 &&
                    val?.filterValue
                  ) {
                    dispatch(getMarketDropDown(val?.filterValue));
                    let regionTemp: any = regionDropDownList?.find(
                      (item?: any) => item?.value == val?.filterValue
                    );
                    if (regionTemp) {
                      setSelectedRegion(regionTemp);
                      filterObj[val?.filterName] = regionTemp;
                    }
                  } else if (val?.filterName == "market" && val?.filterValue) {
                    dispatch(
                      getCostCenterByMarket(
                        { marketId: val?.filterValue },
                        true
                      )
                    );
                    setSavedMarket(val?.filterValue);
                  } else if (
                    val?.filterName == "costCenterSearch" &&
                    val?.filterValue
                  ) {
                    setSavedCostCenter(val?.filterValue);
                  }
                  else if (val?.filterName == "year") {
                    const findValue = yearList?.current?.find(
                      (item: any) => item.value == val?.filterValue
                    );
                    yearSelected.current = findValue?.label;
                    filterObj[val?.filterName] = findValue?.label;
                  } else if (val?.filterName == "glCategory") {
                    const findValue = glCategoryList?.current?.find(
                      (item: any) => item.value == val?.filterValue
                    );
                    glCategorySelected.current = findValue?.label;
                    filterObj[val?.filterName] = findValue?.label;
                  } else if (val?.filterName == "equipmentClass") {
                    const findValue = equipmentClassList?.current?.find(
                      (item: any) => item.value == val?.filterValue
                    );
                    equipmentClassSelected.current = findValue?.label;
                    filterObj[val?.filterName] = findValue?.label;
                  } else if (val?.filterName == "state") {
                    const findValue = stateList?.current?.find(
                      (item: any) => item.value == val?.filterValue
                    );
                    stateSelected.current = findValue?.label;
                    filterObj[val?.filterName] = findValue?.label;
                  } else if (val?.filterName == "parent") {
                    const findValue = parentList?.current?.find(
                      (item: any) => item.value == val?.filterValue
                    );
                    parentSelected.current = findValue?.label;
                    filterObj[val?.filterName] = findValue?.label;
                  }
                  else if (val?.filterName == "importDate" || val?.filterName == "placedInService") {
                    const value = val?.filterValue ? new Date(val?.filterValue) : null;
                    filterObj[val?.filterName] = value;
                  }
                  else {
                    filterObj[val?.filterName] = val?.filterValue;
                  }
                });

              dispatch(setActiveAssetReportGridFilter(filterObj));
            });
          }
        });
      } else {
        yearSelected.current = activeAssetReportGridFilters?.year ?? "";
        glCategorySelected.current =
          activeAssetReportGridFilters?.glCategory ?? "";
        equipmentClassSelected.current =
          activeAssetReportGridFilters?.equipmentClass ?? "";
        stateSelected.current = activeAssetReportGridFilters?.state ?? "";
        parentSelected.current = activeAssetReportGridFilters?.parent ?? "";
        placedInService.current = activeAssetReportGridFilters?.placedInService ? new Date(activeAssetReportGridFilters?.placedInService) : null;
        importDate.current = activeAssetReportGridFilters?.importDate ? new Date(activeAssetReportGridFilters?.importDate) : null;

        assetNumberSelected.current =  '';
        companyNumberSelected.current = "";
        unitNumberSelected.current =  '';
        vinNumberSelected.current = '';
        equipmentClassDescSelected.current = '';
        descriptionSelected.current = '';
        acquisitionCostSelected.current = '';
        netBookedValueSelected.current = '';
        parentNumberSelected.current = '';
        usefulLifeMonthsSelected.current = '';
        remainingLifeMonthsSelected.current = '';
        currentMonthDepreciationSelected.current = '';
        runRateDepreciationSelected.current = '';

        delete  activeAssetReportGridFilters?.assetNumber
        delete  activeAssetReportGridFilters?.unitNumber
        delete  activeAssetReportGridFilters?.serialNumber
        delete  activeAssetReportGridFilters?.equipmentClassDescription
        delete  activeAssetReportGridFilters?.description
        delete  activeAssetReportGridFilters?.cost
        delete  activeAssetReportGridFilters?.remainingNetBookValue
        delete  activeAssetReportGridFilters?.parentNumber
        delete  activeAssetReportGridFilters?.usefulLifeMonths
        delete  activeAssetReportGridFilters?.remainingLifeMonths
        delete  activeAssetReportGridFilters?.currentMonthDepreciation
        delete  activeAssetReportGridFilters?.runRateDepreciation
        delete activeAssetReportGridFilters?.companyNumber
        dispatch(setActiveAssetReportGridFilter(activeAssetReportGridFilters));

        if (activeAssetReportGridFilters?.region) {
          setSelectedRegion(activeAssetReportGridFilters?.region);
          dispatch(
            getMarketDropDown(activeAssetReportGridFilters?.region?.key)
          );
        }
        if (activeAssetReportGridFilters?.market) {
          dispatch(
            getCostCenterByMarket(
              { marketId: activeAssetReportGridFilters?.market?.key },
              true
            )
          );
          setSelectedMarket(activeAssetReportGridFilters?.market);
        }
        if (activeAssetReportGridFilters?.costCenterSearch) {
          setSelectedCostCenter(activeAssetReportGridFilters?.costCenterSearch);
        }
      }
    }
  };

  useEffect(() => {
    if (
      regionDropDownList?.length &&
      yearList?.current?.length &&
      glCategoryList?.current?.length &&
      equipmentClassList?.current?.length &&
      stateList?.current?.length &&
      parentList?.current?.length &&
      userDetails?.hasOwnProperty("userGridFilters") &&
      !isClearFilterClicked
    ) {
      setSavedFilterValues();
    }
  }, [
    userDetails,
    regionDropDownList,
    yearList?.current,
    glCategoryList?.current,
    equipmentClassList?.current,
    stateList?.current,
    parentList?.current,
  ]);

  useEffect(() => {
    if (
      activeAssetReportExcelData != null &&
      activeAssetReportExcelData?.status == "success" &&
      activeAssetReportExcelData?.response?.length
    ) {
      const bytes = base64ToArrayBuffer(activeAssetReportExcelData?.response);
      saveByteArray(
        "ActiveAssetReport",
        bytes,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
      dispatch(setActiveAssetReportExcelData([]));
    }
  }, [activeAssetReportExcelData]);

  useEffect(()=>{
    acquisitionCostSelected.current = activeAssetReportGridFilters?.cost
  },[activeAssetReportGridFilters?.cost])

  useEffect(()=>{
    placedInService.current = activeAssetReportGridFilters?.placedInService ? new Date (activeAssetReportGridFilters?.placedInService) : null
  },[activeAssetReportGridFilters?.placedInService])

  useEffect(()=>{
    importDate.current = activeAssetReportGridFilters?.importDate ? new Date (activeAssetReportGridFilters?.importDate) : null
  },[activeAssetReportGridFilters?.importDate])

  useEffect(()=>{
    runRateDepreciationSelected.current = activeAssetReportGridFilters?.runRateDepreciation
   },[activeAssetReportGridFilters?.runRateDepreciation])

   useEffect(()=>{
    netBookedValueSelected.current = activeAssetReportGridFilters?.remainingNetBookValue
   },[activeAssetReportGridFilters?.remainingNetBookValue])

   useEffect(()=>{
    currentMonthDepreciationSelected.current = activeAssetReportGridFilters?.currentMonthDepreciation
   },[activeAssetReportGridFilters?.currentMonthDepreciation])

    useEffect(()=>{
      companyNumberSelected.current = activeAssetReportGridFilters?.companyNumber
    },[activeAssetReportGridFilters?.companyNumber])

  useEffect(()=>{
    assetNumberSelected.current = activeAssetReportGridFilters?.assetNumber
  },[activeAssetReportGridFilters?.assetNumber])

  useEffect(()=>{
    parentNumberSelected.current = activeAssetReportGridFilters?.parentNumber
  },[activeAssetReportGridFilters?.parentNumber])

  useEffect(()=>{
    usefulLifeMonthsSelected.current = activeAssetReportGridFilters?.usefulLifeMonths
  },[activeAssetReportGridFilters?.usefulLifeMonths])

  useEffect(()=>{
    remainingLifeMonthsSelected.current = activeAssetReportGridFilters?.remainingLifeMonths
  },[activeAssetReportGridFilters?.remainingLifeMonths])

  useEffect(()=>{
    unitNumberSelected.current = activeAssetReportGridFilters?.unitNumber
  },[activeAssetReportGridFilters?.unitNumber])

  useEffect(()=>{
    vinNumberSelected.current = activeAssetReportGridFilters?.serialNumber
  },[activeAssetReportGridFilters?.serialNumber])

  useEffect(()=>{
    equipmentClassDescSelected.current = activeAssetReportGridFilters?.equipmentClassDescription
  },[activeAssetReportGridFilters?.equipmentClassDescription])

  useEffect(()=>{
    descriptionSelected.current = activeAssetReportGridFilters?.description
  },[activeAssetReportGridFilters?.description])

  useEffect(()=>{
    glCategorySelected.current = activeAssetReportGridFilters?.glCategory
  },[activeAssetReportGridFilters?.glCategory])

  useEffect(()=>{
    equipmentClassSelected.current = activeAssetReportGridFilters?.equipmentClass
  },[activeAssetReportGridFilters?.equipmentClass])

  useEffect(()=>{
    yearSelected.current = activeAssetReportGridFilters?.year
  },[activeAssetReportGridFilters?.year])

  useEffect(()=>{
    stateSelected.current = activeAssetReportGridFilters?.state
  },[activeAssetReportGridFilters?.state])

  useEffect(()=>{
    parentSelected.current = activeAssetReportGridFilters?.parent
  },[activeAssetReportGridFilters?.parent])

  const debounceObject = [
    paginationData,
    searchBoxValue,
    sortData,
    yearSelected,
    glCategorySelected,
    equipmentClassSelected,
    stateSelected,
    companyNumberSelected,
    parentSelected,
    globalSearchBy,
    assetNumberSelected,
    parentNumberSelected,
    usefulLifeMonthsSelected,
    remainingLifeMonthsSelected,
    currentMonthDepreciationSelected,
    runRateDepreciationSelected,
    unitNumberSelected,
    vinNumberSelected,
    equipmentClassDescSelected,
    descriptionSelected,
    acquisitionCostSelected,
    netBookedValueSelected,
    importDate,
    placedInService,
    isClearFilterClicked,
  ];
  const globalDebounce = useDebounce(debounceObject, 500);

  const getFilteredValues = () => {
    const filters = [
      { field: "assetNumber", value: assetNumberSelected.current },
      { field: "companyNumber", value: companyNumberSelected.current },
      { field: "parent", value: parentSelected.current },
      { field: "description", value: descriptionSelected.current },
      { field: "glCategory", value: glCategorySelected.current },
      { field: "unitNumber", value: unitNumberSelected.current },
      { field: "equipmentClass", value: equipmentClassSelected.current },
      { field: "equipmentClassDescription", value: equipmentClassDescSelected.current },
      { field: "year", value: yearSelected.current },
      { field: "state", value: stateSelected.current },
      { field: "parentNumber", value: parentNumberSelected.current },
      { field: "serialNumber", value: vinNumberSelected.current },
      { field: "placedInService", value: placedInService.current ? moment(placedInService.current).format("YYYY-MM-DD") : null },
      { field: "usefulLifeMonths", value: usefulLifeMonthsSelected.current },
      { field: "remainingLifeMonths", value: remainingLifeMonthsSelected.current },
      { field: "cost", value: acquisitionCostSelected.current },
      { field: "remainingNetBookValue", value: netBookedValueSelected.current },
      { field: "currentMonthDepreciation", value: currentMonthDepreciationSelected.current },
      { field: "runRateDepreciation", value: runRateDepreciationSelected.current },
      { field :"importDate" , value : importDate.current ? moment(importDate.current).format("YYYY-MM-DD") : null}
    ];

    return filters.filter(filter =>
      filter.value !== "" &&
      filter.value !== undefined &&
      filter.value != null &&
      (!Array.isArray(filter.value) || filter.value.length > 0)
    );

  };

  const syncPaginationToFirstPage = useCallback(() => {
    setPaginationData((prev: any) => {
      const nextPaginationData = { ...prev, pageIndex: 0 };
      dispatch(setActiveAssetReportGridFilter(nextPaginationData));
      return nextPaginationData;
    });
  }, [dispatch]);

  const fetchGridData = (callType?: any) => {
    const shouldForceFirstPageForSearch = resetToFirstPageOnNextFetchRef.current;
    let payload: any = {
      pageNumber : shouldForceFirstPageForSearch ? 1 : paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined,
      pageSize: paginationData?.pageSize,
      columnFilters: isClearFilterClicked ? [] : getFilteredValues(),
      loggedInMail: userDetails?.emailId,
    };
    if (searchBoxValue) {
      payload.globalSearch = searchBoxValue;
      payload.globalSearchField = globalSearchBy.value;
    }
    if (selectedRegion?.label) {
      payload.regionId = isClearFilterClicked ? "" : selectedRegion?.key;
    }
    if (selectedMarket?.label) {
      payload.marketId = isClearFilterClicked ? "" : selectedMarket?.key;
    }
    if (selectedCostCenter?.label) {
      payload.costCenterId = isClearFilterClicked
        ? ""
        : selectedCostCenter?.key;
    }

    if (sortData?.key != "") {
      payload.sortBy = sortData?.key;
      payload.sortOrder = sortData?.sortDirection;
    }

    let monthFiler = getDropdownPayload();
    if (monthFiler) {
      payload.ImportYear = monthFiler?.ImportYear;
      payload.ImportMonth = monthFiler?.ImportMonth;
    }

    // Only the grid fetch consumes the "force page 1" intent — an Excel export triggered in
    // between should not swallow a pending search-triggered page reset meant for the grid fetch.
    if (callType === "grid") {
      resetToFirstPageOnNextFetchRef.current = false;
    }

    if (userDetails?.emailId && payload?.pageNumber) {
      const areEqual = JSON.stringify(payload) === JSON.stringify(sentPayload);
      if (callType === "excel") {
        dispatch(getActiveAssetReportExcelData(payload));
      } else if (!areEqual && callType === "grid") {
        setSentPayload(payload)
        dispatch(getActiveAssetReportGridData(payload))
      }
    }
  };

  // Force page 1 only when the global search term actually changes (not on every fetch while a search is active),
  // so subsequent pager clicks (page 2/3...) while a search is active are respected.
  useEffect(() => {
    const normalizedSearchText = `${searchBoxValue ?? ''}`.trim();
    const currentSearchSignature = `${globalSearchBy?.value ?? globalSearchBy ?? ''}::${normalizedSearchText}`;
    const currentPageIndex = paginationData?.pageIndex ?? 0;

    if (previousGlobalSearchSignatureRef.current === null) {
      previousGlobalSearchSignatureRef.current = currentSearchSignature;
      return;
    }

    const hasSearchChanged = currentSearchSignature !== previousGlobalSearchSignatureRef.current;
    previousGlobalSearchSignatureRef.current = currentSearchSignature;

    if (hasSearchChanged) {
      resetToFirstPageOnNextFetchRef.current = true;
      remountGridOnNextResponseRef.current = true;
      if (currentPageIndex !== 0) {
        syncPaginationToFirstPage();
        setGridRemountKey((k: number) => k + 1);
      }
    }
  }, [globalDebounce, paginationData?.pageIndex, syncPaginationToFirstPage]);

  useEffect(() => {
    fetchGridData("grid");
  }, [globalDebounce]);

  useEffect(() => {
    if(userDetails?.emailId && gridData?.length == 0){
      fetchGridData("grid");
    }
  }, [userDetails]);

  useEffect(() => {
    if (searchBoxValue) {
      resetToFirstPageOnNextFetchRef.current = true;
      remountGridOnNextResponseRef.current = true;
      fetchGridData("grid");
    }
  }, [globalSearchBy]);

  const breadcrumlist = [
    { text: "Active Assets Register Report", key: "f2" },
    {}
  ];


  const handleChange = (value: any, name: string) => {
    switch (name) {
      case "region":
        setSelectedRegion(value);
        setSelectedMarket("");
        setSelectedCostCenter("");
        dispatch(getMarketDropDown(value?.key));
        break;
      case "market":
        setSelectedMarket(value);
        setSelectedCostCenter("");
        dispatch(getCostCenterByMarket({ marketId: value?.key }, true));
        break;
      case "costCenter":
        setSelectedCostCenter(value);
        break;
      default:
        break;
    }
  };

  const getFilteredValue = (columnName: any) => {
    return activeAssetReportGridFilters[columnName];
  };

  const renderDateCell = (key: string) => {
    return (row: any) => (
      <p className="dateSubmitted">
        {row?.rowData?.[key] ? moment(row?.rowData?.[key]).format("MM/DD/YYYY") : ""}
      </p>
    );
  };

  const activeAssetRegisterColumn = [
    {
      key: "assetNumber",
      title: "Asset ID",
      width: 70,
      style: { textAlign: "center" },
      filterRowValue: getFilteredValue("assetNumber") ?? "",
    },
    {
      key: "description",
      title: "Description",
      width: 200,
      filterRowValue: getFilteredValue("description") ?? "",
    },
    {
      key: "glCategory",
      title: "GL Category",
      width: 120,
      FilterCell: (statusProps: any) => {
        return (
          <CustomDropdownFilterComponent
            {...statusProps}
            options={glCategoryList?.current}
            setDropdown={glCategorySelected}
          />
        );
      },
      filterRowValue: getFilteredValue("glCategory") ?? "",
    },
    {
      key: "unitNumber",
      title: "Unit #",
      width: 120,
      filterRowValue: getFilteredValue("unitNumber") ?? "",
    },
    {
      key: "equipmentClass",
      title: "Eq Class Code",
      width: 160,
      FilterCell: (statusProps: any) => {
        return (
          <CustomDropdownFilterComponent
            {...statusProps}
            options={equipmentClassList?.current}
            setDropdown={equipmentClassSelected}
          />
        );
      },
      filterRowValue: getFilteredValue("equipmentClass") ?? "",
    },
    {
      key: "equipmentClassDescription",
      title: "Eq Class Description",
      width: 200,
      filterRowValue: getFilteredValue("equipmentClassDescription") ?? "",
    },
    {
      key: "year",
      title: "Year",
      width: 100,
      FilterCell: (statusProps: any) => {
        return (
          <CustomDropdownFilterComponent
            {...statusProps}
            options={yearList?.current}
            setDropdown={yearSelected}
          />
        );
      },
      filterRowValue: getFilteredValue("year") ?? "",
    },
    {
      key: "state",
      title: "State",
      width: 120,
      FilterCell: (statusProps: any) => {
        return (
          <CustomDropdownFilterComponent
            {...statusProps}
            options={stateList?.current}
            setDropdown={stateSelected}
          />
        );
      },
      filterRowValue: getFilteredValue("state") ?? "",
    },
    {
      key: "companyNumber",
      title: "Company #",
      width: 120,
      filterRowValue: getFilteredValue("companyNumber") ?? "",
    },
    {
      key: "parentNumber",
      title: "Parent #",
      width: 120,
      filterRowValue: getFilteredValue("parentNumber") ?? "",
    },
    {
      key: "parent",
      title: "Parent",
      width: 120,
      FilterCell: (statusProps: any) => {
        return (
          <CustomDropdownFilterComponent
            {...statusProps}
            options={parentList?.current}
            setDropdown={parentSelected}
          />
        );
      },
      filterRowValue: getFilteredValue("parent") ?? "",
    },
    {
      key: "serialNumber",
      title: "Serial #",
      width: 120,
      filterRowValue: getFilteredValue("serialNumber") ?? "",
    },
    {
      key: "placedInService",
      title: "Placed In Service",
      width: 200,
      Cell: renderDateCell("placedInService"),
      FilterCell: (props: any) => (<CustomDateFilterComponent {...props} setDate={placedInService} />),
      filterRowValue: getFilteredValue("placedInService") ?? "",
    },
    {
      key: "usefulLifeMonths",
      title: "Useful Life Months",
      width: 200,
      filterRowValue: getFilteredValue("usefulLifeMonths") ?? "",
    },
    {
      key: "remainingLifeMonths",
      title: "Remaining Life Months",
      width: 100,
      filterRowValue: getFilteredValue("remainingLifeMonths") ?? "",
    },
    {
      key: "cost",
      title: "Cost ($)",
      Cell: (row: any) => {
        return row.rowData.cost != null 
            ? `$ ${formatPrice(row.rowData.cost || 0, 2)}` 
            : null;
      },
      width: 100,
      // FilterCell: () => {
      //   return <CustomTextFilterDiv orderPriceFilter = {acquisitionCostSelected.current} onChange = {(e: any) => orderPriceFilterOnchange(e , 'cost')} />;
      // },
      filterRowValue: getFilteredValue("cost") ?? "",
    },
    {
      key: "remainingNetBookValue",
      title: "Remaining Net Book Value ($)",
      width: 200,
      Cell: (row: any) => {
        return row.rowData.remainingNetBookValue != null 
            ? `$ ${formatPrice(row.rowData.remainingNetBookValue || 0, 2)}` 
            : null;
      },
      // FilterCell: () => {
      //   return <CustomTextFilterDiv orderPriceFilter = {netBookedValueSelected.current} onChange = {(e: any) => orderPriceFilterOnchange(e , 'remainingNetBookValue')} />;
      // },
      filterRowValue: getFilteredValue("remainingNetBookValue") ?? "",
    },
    {
      key: "currentMonthDepreciation",
      title: "Current Month Depreciation ($)",
      width: 100,
      Cell: (row: any) => {
        return row.rowData.currentMonthDepreciation != null 
            ? `$ ${formatPrice(row.rowData.currentMonthDepreciation || 0, 2)}` 
            : null;
      },
      // FilterCell: () => {
      //   return <CustomTextFilterDiv orderPriceFilter = {currentMonthDepreciationSelected.current} onChange = {(e: any) => orderPriceFilterOnchange(e , 'currentMonthDepreciation')} />;
      // },
      filterRowValue: getFilteredValue("currentMonthDepreciation") ?? "",
    },
    {
      key: "runRateDepreciation",
      title: "Runrate Depreciation ($)",
      width: 200,
      Cell: (row: any) => {
        return row.rowData.runRateDepreciation != null 
            ? `$ ${formatPrice(row.rowData.runRateDepreciation || 0, 2)}` 
            : null;
      },
      // FilterCell: () => {
      //   return <CustomTextFilterDiv orderPriceFilter = {runRateDepreciationSelected.current} onChange = {(e: any) => orderPriceFilterOnchange(e , 'runRateDepreciation')} />;
      // },
      filterRowValue: getFilteredValue("runRateDepreciation") ?? "",
    },
    {
      key: "importDate",
      title: "Import Date",
      width: 200,
      Cell: renderDateCell("importDate"),
      FilterCell: (props: any) => (<CustomDateFilterComponent {...props} setDate={importDate} />),
      filterRowValue: getFilteredValue("importDate") ?? "",
    },
  ];

  const onClickExport = (e?: any) => {
    e.preventDefault();
    fetchGridData("excel");
  };

  const searchOptions = [
    { value: "assetNumber", label: "Asset#" },
    { value: "unitNumber", label: "Unit#" },
    { value: "serialNumber", label: "Serial#" },
  ];


  const clearFilterValues = {
    assetNumber: "",
    companyNumber: "",
    parentNumber: "",
    parent: "",
    runRateDepreciation: "",
    currentMonthDepreciation: "",
    usefulLifeMonths: "",
    remainingLifeMonths: "",
    unitNumber: "",
    serialNumber: "",
    year: "",
    glCategory: "",
    equipmentClass: "",
    equipmentClassDescription: "",
    description: "",
    state: "",
    cost: "",
    remainingNetBookValue: "",
    globalSearchField: null,
    orderSearchBoxValue: "",
    loggedInMail: "",
    costCenterSearch: "",
    region: "",
    market: "",
    placedInService: null,
    importDate: null
  };

  const handleFilterClear = () => {
    setIsClearFilterClicked(true);
    dispatch(getRegionDropDown());
    setSelectedCostCenter("");
    setSelectedMarket("");
    setSelectedRegion("");
    setCostCenterDropdownList([]);
    setMarketDropDownList([]);
    dispatch(setActiveAssetReportGridFilter(clearFilterValues));
    setsearchBoxValue("");
    setGlobalSearchBy({ value: "assetNumber", label: "Asset #" });
    setShowGrid(false);

    if(isDateFilterClicked){
      setIsDateFilterClicked(false);
      setSelectedDate(lastImportDate);
    }

    yearSelected.current = "";
    glCategorySelected.current = "";
    equipmentClassSelected.current = "";
    stateSelected.current = "";
    parentSelected.current = "";

    setTimeout(() => {
      setShowGrid(true);
    });
  };

  useEffect(() => {
    if (serverTotal && paginationData?.pageSize) {
      let pageSize = paginationData?.pageSize;
      let tempPageCount =
        serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0;
      setPagesCount(tempPageCount);
    }
  }, [serverTotal, paginationData?.pageSize]);

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      let paginationData = fetchData.data;
      setPaginationData(paginationData);
      dispatch(setActiveAssetReportGridFilter(paginationData));
    }
    if (fetchData.action && fetchData.action === "sorting") {
      const data = fetchData.data[0];
      setSortData(data);
      dispatch(setActiveAssetReportGridFilter({ sortData: data }));
    }
  }, []);

  const setFilters = (value: any) => {
   // if (JSON.stringify(value) !== "{}") {
      dispatch(setActiveAssetReportGridFilter(value));
   // }
  };

  const onSearchOrder = (e: any, isKeyPress?: any) => {
    setsearchBoxValue(isKeyPress ? e : e?.target?.value);
    dispatch(
      setActiveAssetReportGridFilter({
        orderSearchBoxValue: isKeyPress ? e : e?.target?.value,
      })
    );
  };

  const onGlobalSearchByChange = (value: any) => {
    setGlobalSearchBy(value);
    dispatch(setActiveAssetReportGridFilter({ globalSearchField: value }));
  };

    const handleSearchGrid = () => {
    resetToFirstPageOnNextFetchRef.current = true;
    remountGridOnNextResponseRef.current = true;
    if ((paginationData?.pageIndex ?? 0) !== 0) {
      syncPaginationToFirstPage();
      setGridRemountKey((key: number) => key + 1);
    }
    dispatch(
      setActiveAssetReportGridFilter({
        ...activeAssetReportGridFilters,
        region: selectedRegion,
        market: selectedMarket,
        costCenterSearch: selectedCostCenter,
      })
    );
    fetchGridData("grid");
  };

  const setCurrentMonthDateFilter = () => {
    setSelectedDate(lastImportDate);
  };


  const handleDateChange = (value: any) => {
    if (value) {
      setSelectedDate(moment(value));
    } else {
      setCurrentMonthDateFilter();
    }
  };

  useEffect(() => {
    if (isInitialSet.current) {
      isInitialSet.current = false;
      return;
    }
    if (selectedDate && prevSelectedDate.current && selectedDate !== prevSelectedDate.current) {
      fetchGridData("grid");
    }
    prevSelectedDate.current = selectedDate;

    let lstImportDate = lastImportDate?.format('YYYY-MM');
    let slctImportDate = selectedDate?.format('YYYY-MM');
    if(slctImportDate && slctImportDate != lstImportDate){
      setIsDateFilterClicked(true);
    }else{
      setIsDateFilterClicked(false);
    }
  }, [selectedDate]);

  const alreadyHasGridFilterValues = useCallback(() => {
    let isAlreadyHasValues = true;
    let GridFilterValueTemp: any = activeAssetReportGridFilters;
    Object.keys(clearFilterValues)?.forEach((filterItem?: any) => {
      Object.keys(GridFilterValueTemp ?? {})?.forEach((gridItem?: any) => {
        if (filterItem == gridItem) {
          let val = gridItem;
          if (
            GridFilterValueTemp[val] != "" &&
            GridFilterValueTemp[val] != null &&
            GridFilterValueTemp[val] != undefined &&
            val != "globalSearchField" &&
            val != "loggedInMail"
          ) {
            isAlreadyHasValues = false;
          }
        }
      });
    });
    if (isDateFilterClicked ){
      return false;
    }else{
      return isAlreadyHasValues;
    }
  }, [
    activeAssetReportGridFilters,
    selectedRegion,
    selectedMarket,
    selectedCostCenter,
    isClearFilterClicked,
    isDateFilterClicked
  ]);

  return (
    <ActiveAssetRegister
      breadcrumlist={breadcrumlist}
      handleChange={handleChange}
      regionDropDownList={regionDropDownList}
      selectedRegion={selectedRegion}
      activeAssetRegisterColumn={activeAssetRegisterColumn}
      marketDropDownList={marketDropDownList}
      selectedMarket={selectedMarket}
      costCenterDropdownList={costCenterDropdownList}
      selectedCostCenter={selectedCostCenter}
      onClickExport={onClickExport}
      searchOptions={searchOptions}
      globalSearchBy={globalSearchBy}
      handleFilterClear={handleFilterClear}
      fetchAction={fetchAction}
      setFilters={setFilters}
      serverTotal={serverTotal}
      pagesCount={pagesCount}
      onSearchOrder={onSearchOrder}
      onGlobalSearchByChange={onGlobalSearchByChange}
      searchBoxValue={searchBoxValue}
      showGrid={showGrid}
      isGridDataLoading={isReportGridDataLoading}
      activeAssetGridData={gridData}
      handleSearchGrid={handleSearchGrid}
      alreadyHasGridFilterValues={alreadyHasGridFilterValues}
      isReport={true}
      selectedDate={selectedDate}
      handleDateChange={handleDateChange}
      validStartDate = {validStartDate}
      validEndDate = {validEndDate}
      lastRefreshedDate = {activeAssetReportDropdownGridData?.response?.lastImportDate}
      gridRemountKey={gridRemountKey}
    />
  );
};

export default ActiveAssetReportContainer;
